import { RemoteActivity } from '../types';
import { post } from '../utils';
import { Dispatch, UnknownAction } from 'redux';

const UPDATE = 'UPDATE_ACTIVITIES';

interface ActivitiesAction extends UnknownAction {
  activities: RemoteActivity[];
}

export function activitiesReducer(activities: RemoteActivity[] = [], action: ActivitiesAction): RemoteActivity[] {
  if (action.type === UPDATE) {
    return action.activities || [];
  }
  return activities;
}

const activitiesFilter = {};

export const fetchActivitiesAction =
  (dispatch: Dispatch) =>
  (filter: { [key: string]: unknown }): void => {
    Object.assign(activitiesFilter, filter);
    post<RemoteActivity[]>('/aktiviteter/api/activities', JSON.stringify(activitiesFilter))
      .then((activities) => {
        dispatch({ type: UPDATE, activities });
      })
      .catch(function (ex) {
        console.error('Failed to fetch activities', ex);
      });
  };
